<script setup lang="ts">
import { computed } from "vue";

import GenericNavbar from "@/components/header/GenericNavbar.vue";
import { useAuthStore, useMenuStore } from "@/stores";

const props = defineProps<{
  triggerId: string;
}>();

const menuStore = useMenuStore();
const authStore = useAuthStore();

const username = computed<string>(() => authStore.user.username);
const className = computed<string>(() => authStore.user.className);
const institutionName = computed<string>(() => authStore.getPrimaryInstitutionName());
</script>

<template>
  <GenericNavbar
    :trigger-id="props.triggerId"
    :items="menuStore.menuItems"
    @toggle="menuStore.toggleMenu()"
    @hide="menuStore.hideMenu()"
  >
    <div class="main-navbar__info">
      <div class="main-navbar__user-info">
        <span class="main-navbar__username">{{ username }}</span>
        <span class="main-navbar__class">
          {{ $t("settings.sidebar.class", { class: className }) }}
        </span>
      </div>
      <div class="main-navbar__institution">{{ institutionName }}</div>
    </div>
  </GenericNavbar>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.main-navbar {
  &__info {
    margin-top: 6px;
    padding: 10px 10px 0;
    border-top: 1px solid rgb(@theme-colors[@grey][50]);
    font-size: 0.75rem;
  }

  &__user-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 0 5px;
  }

  &__username {
    min-width: 75px;
    .fade-text();
  }

  &__class {
    color: rgb(@theme-colors[@grey][base]);
  }

  &__institution {
    .fade-text();
  }
}
</style>
